import { create } from 'zustand'
import * as MeetingAPI from '../../../API/MeetingAPI'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

const initialState = {

    // view meeting
    viewMeetingDetails: {},
    viewMeetingLoading: false,
    viewMeetingError: '',

    // getUpcomingEvent
    getUpcomingEventLoading: false,
    getUpcomingEventError: '',
    getUpcomingEventData: [],

    // newMeeting
    createNewMeeting: {},
    createNewMeetingLoading: false,
    createNewMeetingError: '',

    // newMeeting
    getDate: { from: new Date(), to: new Date() },
    getDateLoading: false
}

const MeetingStore = (set) => ({
    ...initialState,

    getViewMeetingDetailsById: async (meetingId) => {
        set({ ...initialState, viewMeetingLoading: true })
        try {
            const response = await MeetingAPI.getViewMeetingDetailsById(meetingId)
            if (response.data) {
                set({ ...initialState, viewMeetingLoading: false, viewMeetingDetails: response.data })
            } else {
                set({ ...initialState, viewMeetingLoading: false, viewMeetingError: 'Meeting details not found' })
            }
        } catch (err) {
            // set({ ...initialState, viewMeetingLoading: false, viewMeetingError: err.message || 'An error occurred' })
        }
    },
    getUpcomingEvent: async (data) => {
        set({ getUpcomingEventLoading: true })
        try {
            const response = await MeetingAPI.GetUpcommingEvents(data)
            set({ getUpcomingEventData: response.data, getUpcomingEventLoading: false })
        } catch (error) {
            set({ getUpcomingEventError: error.message || 'An error occurred', getUpcomingEventLoading: false })
        }
    },
    createMeeting: async (newdata) => {
        set({ createNewMeetingLoading: true })
        try {
            const data = await MeetingAPI.createMeeting(newdata)
            set({ createNewMeeting: data, createNewMeetingLoading: false })
        } catch (error) {
            set({ createNewMeetingLoading: false, createNewMeetingError: error.message || 'An Error occured' })
        }
    },
    setDateFromMeetingSheduler: async (date) => {
        set({ getDateLoading: true })
        try {
            set({ getDate: date, getDateLoading: false })
        } catch (error) {
            set({ getDateLoading: false })
        }
    }
})

export const useMeetingStore = create(devtools(immer(MeetingStore)))
